import "./formSegment.scss";

import { isNil } from "lodash";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import keyConstants from "../../constants/keyConstants";
import { PropTypeShapes } from "../../types";
import Icon from "../interface/Icon";
import onPulseAnimationEnd from "../onPulseAnimationEnd";

const renderSegment = (opt, isSelected, pulsateIconId, onChange, onClick) => {
  let className = ["formSegment"];
  if (isSelected) {
    className.push("selected");
  }
  if (!isNil(pulsateIconId) && pulsateIconId === opt.interfaceIdentifier) {
    className.push("pulse");
  }
  const onClickFunc = onChange
    ? isSelected
      ? null
      : () => onChange(opt.value)
    : onClick
      ? () => onClick(opt.value)
      : null;
  return (
    <div key={opt.value} className={className.join(" ")} onClick={onClickFunc} onAnimationEnd={onPulseAnimationEnd}>
      <span>
        {opt.icon ? <Icon icon={opt.icon} color="iconMono" /> : null}
        {opt.badgeCount ? <span className={`badge ${opt.badgeColor}`}>{opt.badgeCount}</span> : null}
        <span>{opt.label}</span>
      </span>
    </div>
  );
};

export default class FormSegmentControl extends PureComponent {
  constructor(props, context) {
    super(props, context);

    this.onKeyDown = this.onKeyDown.bind(this);
  }

  onKeyDown(e) {
    const { options, value, onClick, onChange } = this.props;
    if (!value) {
      return;
    }

    let nextOptIndex = options.findIndex(opt => opt.value === value);
    const optCount = options.length;
    if (e.key === keyConstants.Right) {
      nextOptIndex += 1;
      e.stopPropagation();
      e.preventDefault();
    } else if (e.key === keyConstants.Left) {
      nextOptIndex += optCount - 1;
      e.stopPropagation();
      e.preventDefault();
    }
    const newValue = options[nextOptIndex % optCount].value;
    if (onChange && value !== newValue) {
      onChange(newValue);
    } else if (onClick) {
      onClick(newValue);
    }
  }

  render() {
    const classNames = `formSegmentControl ${this.props.disabled ? "disabled" : ""} ${
      this.props.isDarkColor ? "dark" : ""
    } ${this.props.className ? this.props.className : ""}`;
    return (
      <div className={classNames} tabIndex={0} onKeyDown={this.onKeyDown}>
        {this.props.options.map(opt =>
          renderSegment(
            opt,
            opt.value === this.props.value,
            this.props.pulsateIconId,
            this.props.onChange,
            this.props.onClick
          )
        )}
      </div>
    );
  }
}

FormSegmentControl.propTypes = {
  options: PropTypeShapes.listOptionArray.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  // The onChange will not fire when
  // no changes (ie. click on selected option)
  // while onClick will fire anyway
  onChange: PropTypes.func,
  className: PropTypes.string,
  pulsateIconId: PropTypes.string,
  onClick: PropTypes.func,
  isDarkColor: PropTypes.bool
};
